// "departureAirport" / "return_confirmation_number" -> "Departure Airport" / "Return Confirmation Number"
export const humanizeKey = (key) => String(key)
    .replace(/_/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b([a-z])/g, (m) => m.toUpperCase());
